module.exports = __webpack_public_path__ + "img/mortar_symbol_green.780bfcd4.svg";